import { motion } from "framer-motion";
import { SERVICES } from "@/content/site";
import { Reveal } from "@/components/Reveal";

export const ServicesSection = ({ title = "Everything your pool needs, handled", overline = "Our Services", intro }) => (
  <section data-testid="services-section" className="py-16 sm:py-24 lg:py-32 bg-shell">
    <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-pool font-semibold">{overline}</p>
        <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-navy max-w-2xl">
          {title}
        </h2>
        {intro && <p className="mt-5 text-base text-slate-600 leading-relaxed max-w-2xl">{intro}</p>}
      </Reveal>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.title}
            data-testid={`service-card-${i}`}
            initial={{ opacity: 0, y: 26 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -6 }}
            className="group bg-white rounded-2xl border border-slate-200/80 p-6 sm:p-7 transition-shadow duration-300 hover:shadow-xl hover:shadow-cyan-500/10"
          >
            <span className={`w-12 h-12 rounded-xl flex items-center justify-center transition-colors duration-300 ${i % 2 ? "bg-emerald-50 group-hover:bg-pine" : "bg-mist group-hover:bg-navy"}`}>
              <s.icon className={`w-6 h-6 transition-colors duration-300 ${i % 2 ? "text-lagoon group-hover:text-lagoonlight" : "text-pool group-hover:text-sky2"}`} />
            </span>
            <h3 className="mt-5 font-display text-lg font-semibold text-navy tracking-tight leading-snug">{s.title}</h3>
            <p className="mt-2.5 text-sm text-slate-500 leading-relaxed">{s.blurb}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
